import riperTranslations from '@/assets/i18n/riper.json';

/* Translation Helper */
export const I18n = function () {
  const stringsURL = '$$TRANSLATION_FILE$$';
  return {
    _language: null,
    _Strings: {},
    async load(language) {
      const languageISO = language.iso.toLowerCase();
      const cacheKey = `riper-${languageISO}-${window.Beans3.DEPLOY_VERSION_HASH}`;
      const url = stringsURL.replace('{app}', 'riper').replace('{lang}', languageISO);
      let translations = localStorage.getItem(cacheKey);
      if (translations) return JSON.parse(translations);

      if (languageISO === 'en') return riperTranslations;

      const response = await fetch(url);
      if (response.ok) {
        translations = await response.json();
        localStorage.setItem(cacheKey, JSON.stringify(translations));
        return translations;
      }

      throw Error(`Unable to fetch translation file from ${url}`);
    },

    async init(language) {
      this._language = language;
      const strings = await this.load(language);
      this._Strings = { ...this._Strings, ...strings, currency_format: language.currency_format };
    },
    t(namespace, phrase, variables = null) {
      let string = this._Strings[namespace][phrase];
      variables &&
        Object.keys(variables).map((key) => {
          const tag = new RegExp(`{${key}}`, 'g');
          string = string && string.replace(tag, variables[key]);
        });
      return string;
    },
    printMoney(symbol, value) {
      let { currency_format: currencyFormat } = this._language;
      currencyFormat = currencyFormat.replace('{symbol}', symbol).replace('{value}', Math.round(value * 100) / 100);
      return currencyFormat;
    },
    formatDate(day, month, year) {
      let dateFormat = `{month} {day}, {year}`;
      dateFormat = dateFormat.replace('{month}', month).replace('{day}', day).replace('{year}', year);
      return dateFormat;
    },
  };
};

const i18n = I18n();

export default i18n;
